import React from 'react'
import styled from 'styled-components'

const BestOfMerchant = () => {
  return (
    <Wrapper>
        <div className='container py-2 '>
            <div className='container d-flex align-items-center justify-content-center mb-1' style={{backgroundColor:'#e9e5e6',}}>
                <h2 className='text-light display-4 display-lg-3 fw-bold py-3 py-lg-4 py-xlg-5 text-dark' >THE BEST OF PUMA</h2>
            </div>
            <div className='container px-0'>
                <div className='row'>
                    <div className='col-lg-6 col-12 my-1 pe-lg-1 d-flex justify-content-center'>
                        <img src='/images/shoes.jpg' className='img-fluid'/>
                    </div>
                    <div className='col-lg-6 col-12 my-1 ps-lg-1 d-flex justify-content-center'>
                        <img src='/images/shoes.jpg' className='img-fluid'/>
                    </div>
                    <div className='col-lg-6 col-12 my-1 pe-lg-1 d-flex justify-content-center'>
                        <img src='/images/shoes.jpg' className='img-fluid'/>
                    </div>
                    <div className='col-lg-6 col-12 my-1 ps-lg-1 d-flex justify-content-center'>
                        <img src='/images/shoes.jpg' className='img-fluid'/>
                    </div>
                    <div className='col-lg-6 col-12 my-1 pe-lg-1 d-flex justify-content-center'>
                        <img src='/images/shoes.jpg' className='img-fluid'/>
                    </div>
                    <div className='col-lg-6 col-12 my-1 ps-lg-1 d-flex justify-content-center'>
                        <img src='/images/shoes.jpg' className='img-fluid'/>
                    </div>
                </div>
            </div>
        </div>
    </Wrapper>
  )
}

export default BestOfMerchant

const Wrapper = styled.section`
    @media(max-width:576px){
        h2{
            font-size:1.3rem;
            margin-bottom: 0;
        }
    }
`;